import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {jwtDecode} from 'jwt-decode';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import ReactStars from 'react-rating-stars-component';
import config from "../config";

const Review = ({ onClose, sellerId }) => {
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const id = decoded.data.customer_data.id;

    const [formData, setFormData] = useState({
        rating: 0,
        review: "",
        sellerId: sellerId
    });

    const [isLoaded, setIsLoaded] = useState(false);
    const [errors, setErrors] = useState({});
    const [isreview,setIsreview]=useState(true)
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.rating) newErrors.rating = "Rating is required";
        if (!formData.review) newErrors.review = "Review is required";
        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleRatingChange = (newRating) => {
        setFormData((prevData) => ({
            ...prevData,
            rating: newRating,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const response = await axios.post(`${config.API_BASE_URL}/customer/addreview/${id}`, formData);
            if (response.status === 201) {
                toast.success("Review added successfully" , {position:"top-center"});
                onClose();
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        const fetchReview = async () => {
            try {
                const response = await axios.get(`${config.API_BASE_URL}/customer/getreview/${id}?sellerId=${sellerId}`);
                if (response.data.review) {
                    setFormData({
                        rating: Number(response.data.review.rating),
                        review: response.data.review.review,
                        sellerId: sellerId
                    });
                    setIsreview(false)
                }
                setIsLoaded(true);
            } catch (error) {
                console.error('Error:', error);
                setIsLoaded(true);
            }
        };

        fetchReview();
    }, [id, sellerId]);

    if (!isLoaded) {
        return <div></div>;
    }

    return (
        <div className="bg-[#fff] flex justify-center items-center">
            <div className="w-full max-w-4xl bg-white rounded-lg overflow-hidden relative">
                <button
                    className="absolute top-0 right-2 text-[#000] border border-[#000] rounded-full h-8 w-8 flex items-center justify-center"
                    onClick={onClose}
                >
                    &times;
                </button>
                <h1 className='text-xl pl-6 text-center'><strong>Rate this kennel</strong></h1>
                <form className="p-6" onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 gap-3">
                        <div>
                            <div className="mt-3 w-full">
                                <ReactStars
                                    count={5}
                                    onChange={handleRatingChange}
                                    size={40}
                                    isHalf={true}
                                    value={formData.rating}
                                    activeColor="#ffd700"
                                    className="block m-auto"
                                />
                            </div>
                            <label className="block text-gray-700">
                                Review this kennel <span className="text-[#ff0000]">*</span>
                                {errors.review && <span className="text-red-500">{errors.review}</span>}
                            </label>
                            <textarea
                                name="review"
                                value={formData.review}
                                onChange={handleChange}
                                className="mt-1 block w-full placeholder-black border border-gray-300 rounded-md shadow-sm p-2 bg-[#F2F2F2] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            />
                        </div>
                    </div>

                   {isreview? 
                    <div className="mt-6 flex items-center justify-end">
                        <button className="bg-[#FF6216] text-white px-4 py-2 rounded-md shadow-sm focus:outline-none h-[40px]">
                            Submit
                        </button>
                    </div>:""}
                </form>
            </div>
        </div>
    );
};

export default Review;
